import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { cofaceAccessTypes } from 'shared/constants/creditReview/cofaceAccessTypes';
import { creditReviewRequestTooltips } from 'shared/constants/creditReview/creditReviewRequestTooltips';
import { addNotificationAction } from 'store/notifications/notificationsActions';
import { useCofaceContract } from '../useCofaceContract/useCofaceContract';

export const useConfirmedRequest = ({ handleRequest, confirmationModalOpen }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [pendingConfirmation, setPendingConfirmation] = useState(false);
  const { confirmed, autoConfirm } = useSelector(({ entity }) => entity.requestConfirmation);
  const { cofaceAccessType } = useCofaceContract();

  const scheduleRequest = () => {
    const isRequestAvailable = cofaceAccessType === cofaceAccessTypes.REQUEST_ALLOWED;

    if (!isRequestAvailable) {
      dispatch(
        addNotificationAction({
          message: t(creditReviewRequestTooltips[cofaceAccessType]),
          variant: 'error',
        }),
      );
      return;
    }

    if (!autoConfirm && confirmationModalOpen) {
      confirmationModalOpen();
    }
    setPendingConfirmation(true);
  };

  useEffect(() => {
    if (pendingConfirmation && (confirmed || autoConfirm)) {
      handleRequest();
      setPendingConfirmation(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmed, autoConfirm, pendingConfirmation]);

  return { scheduleRequest };
};
